import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PfacModel, UpdatePfacModel } from 'src/app/configuration-pfac/models/configuration-pfac.models';
import { PageEvent } from '@angular/material/paginator';
import { CpfCnpjPipe } from 'src/app/shared/pipes/cpf-cnpj.pipe';
import { ConfigurationPfacService } from '../../services/configuration-pfac.service';
import { DialogService } from 'src/app/shared/service/dialog.service';
import { ErrorService } from 'src/app/shared/service/error.service';
import { Messages } from 'src/app/shared/messages/messages';
import { HttpErrorResponse } from '@angular/common/http';
import { LoadingService } from 'src/app/shared/service/loading.service';
import { finalize } from 'rxjs/operators';
import { AuditPfacComponent } from '../audit-pfac/audit-pfac.component';
import { MatDialog } from '@angular/material/dialog';
import { EditPfacComponent } from '../edit-pfac/edit-pfac.component';

@Component({
  selector: 'app-list-pfac',
  templateUrl: './list-pfac.component.html',
  styleUrl: './list-pfac.component.scss',
  standalone: false
})
export class ListPfacComponent implements OnInit, OnChanges {

  constructor(
    private configurationPfacService: ConfigurationPfacService,
    private dialogService: DialogService,
    private errorService: ErrorService,
    private loadingService: LoadingService,
    private dialog: MatDialog,
  ) { }

  displayedColumns = ['idPfac', 'cnpjPfac', 'namePfac', 'createdAtPfac', 'options_edit'];
  defaultSizeItems = 10;

  hasValue = false;

  @Input() dataSource: MatTableDataSource<PfacModel>;
  @Input() totalItens;
  @Input() page;

  @Output() changePage = new EventEmitter<PageEvent>();
  @Output() searchEvent: EventEmitter<void> = new EventEmitter();

  ngOnInit() {}

  ngOnChanges() {
     if (!this.dataSource) {
      return;
    }
    if (this.dataSource.data.length > 0) {
      this.hasValue = true;
    } else {
      this.hasValue = false;
    }
  }

  change(event: PageEvent): void {
    this.changePage.emit(event);
  }

  enable(pfac: PfacModel) {
    this.dialogService.openConfirmDialog(Messages.CONFIRM_ENABLE_PFAC,
        () => {
          this.updatePfacStatus(pfac, true);
        });    
  }

  disable(pfac: PfacModel) {
    this.dialogService.openConfirmDialog(Messages.CONFIRM_DISABLE_PFAC,
        () => {
          this.updatePfacStatus(pfac, false);
        });   
  }

  private updatePfacStatus(pfac: PfacModel, active: boolean) {
    const data = new UpdatePfacModel();
    data.active = active;

    this.loadingService.show();

    this.configurationPfacService.update(pfac.id, data).pipe(
      finalize(() => this.loadingService.hide())
    ).subscribe(() => {
      this.dialogService.openDialog(Messages.EDIT_SAVE_SUCCESS, () => this.searchEvent.emit());
    }, (err: HttpErrorResponse) => {
      this.errorService.handleXHRError(err, Messages.EDIT_SAVE_ERROR);
    });
  }

  showAudit(pfac: PfacModel) {
    this.loadingService.show();
    this.configurationPfacService.getAllAudit(pfac.id).pipe(
      finalize(() => this.loadingService.hide())
    ).subscribe(auditData => {
      this.dialog.open(AuditPfacComponent, {
        width: '80%',
        height: '60%',
        autoFocus: false,
        data: auditData
      });
    }, (err: HttpErrorResponse) => {
      this.errorService.handleXHRError(err, Messages.SEARCH_ERROR);
    }
    );
  }

  edit(pfac: PfacModel) {
    const dialogRef = this.dialog.open(EditPfacComponent, {
      width: '60%',
      height: '50%',
      data: pfac
    });

    dialogRef.afterClosed().subscribe((updated: boolean) => {
      if (updated) {
        this.searchEvent.emit();
      }
    });
  }

}
